<template>
  <div class="home">
    <!-- <HelloWorld /> -->
    <!-- <HomeTable /> -->
    <HomeSimple />
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
//import HomeTable from '@/components/HomeTable.vue'
import HomeSimple from '@/components/HomeSimple.vue'

export default {
  name: 'Home',
  components: {
    //HelloWorld,
    //HomeTable,
    HomeSimple
  }
}
</script>
